<template>
  <div class="animated fadeIn">
    <b-row>      
      <b-col sm="6" lg="3" v-for="stat in statistics.items" :data="statistics" :key="stat.status_id">
        <b-card no-body :style="{color:'#ffffff', backgroundColor:getColor(stat.status_id)}">
          <b-card-body class="pb-0">
            <!-- <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-settings"></i>
              </template>
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else here...</b-dropdown-item>
              <b-dropdown-item disabled>Disabled action</b-dropdown-item>
            </b-dropdown> -->
            <h4 class="mb-0">{{ stat.total_count }}</h4>
            <p>{{ stat.status }}</p>
          </b-card-body>
          <dashboard-chart :dataset="stat.data" :color="getColor(stat.status_id)" :title="stat.status" :label="statistics.label" :chartId="'card-chart-'+ stat.status_id" class="chart-wrapper px-3" style="height:70px;" :height="70"/>

          <!-- <template v-if="stat.status_id === 13"> 
            <user-submitted-chart chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
          </template>
          <template v-if="stat.status_id === 14"> 
            <user-approved-chart chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
          </template>
          <template v-if="stat.status_id === 1"> 
            <user-cancelled-chart chartId="card-chart-03" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
          </template>
          <template v-if="stat.status_id === 2"> 
            <user-pending-chart chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
          </template> -->
        </b-card>
      </b-col>
      <!-- <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <b-dropdown class="float-right" variant="transparent p-0" right no-caret>
              <template slot="button-content">
                <i class="icon-location-pin"></i>
              </template>
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else here...</b-dropdown-item>
              <b-dropdown-item disabled>Disabled action</b-dropdown-item>
            </b-dropdown>
            <h4 class="mb-0">20</h4>
            <p>Approved</p>
          </b-card-body>
          <user-approved-chart chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-settings"></i>
              </template>
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else here...</b-dropdown-item>
              <b-dropdown-item disabled>Disabled action</b-dropdown-item>
            </b-dropdown>
            <h4 class="mb-0">3</h4>
            <p>Cancelled</p>
          </b-card-body>
          <user-cancelled-chart chartId="card-chart-03" class="chart-wrapper" style="height:70px;" height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-settings"></i>
              </template>
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else here...</b-dropdown-item>
              <b-dropdown-item disabled>Disabled action</b-dropdown-item>
            </b-dropdown>
            <h4 class="mb-0">7</h4>
            <p>Pending</p>
          </b-card-body>
          <user-pending-chart chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" height="70"/>
        </b-card>
      </b-col> -->
    </b-row>

    <b-row>
      <b-col sm="12">
         <transition name="fade">
          <b-card no-body>
            <div slot="header">
              Notifications
              <div class="card-header-actions">
                <b-button ref="newNotification" type="button" @click="init" v-b-modal.requestModal v-b-modal.modal-center size="sm" variant="primary"><i class="fa fa-bell-o"></i> New Notification</b-button>
              </div>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <request-table ref="table" @event-handler="eventHandler($event)"></request-table>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
        <!-- <b-card header="Notification Requests">            
            <request-table></request-table>
        </b-card> -->
      </b-col>
    </b-row>

    <!--// MODAL Notification Request -->   
     <b-modal centered ref="requestModal" title="Notification" class="modal-primary" id="requestModal" @ok="submitRequestEventHandler"> <!-- :ok-disabled="cutoffTime" -->
      <b-row>
        <b-col sm="12">
          <b-form>
            <b-row class="mb-3">
                <b-col>
                  <b-form-group class="mb-0" v-if="requestTypeList">
                    <label for="country">Please select the type of notification you want to request</label>
                    <b-form-select
                          ref="requestTypeButton"
                          :disabled="disabledRequestType"
                          class="col-8"
                          v-model="selectedRequestTypeId"
                          :options="requestTypeList" 
                          text-field="description" 
                          value-field="id" 
                          @change="requestTypeEventHandler">
                        <template slot="first">
                            <option :value="null" disabled>-- Please select an option --</option>
                        </template>
                    </b-form-select>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('selectedRequestTypeId') }}</small>
                  </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="selectedRequestTypeId == 1" class="mb-2">
              <b-col>
                  <b-form-group id="notificationSubmit">
                    <label for="notificationSubmit">Select submission type for this amendment?</label>
                    <b-form-radio-group v-model="selectedSubmissionId">
                      <b-form-radio v-bind:value="0">EHOC</b-form-radio>
                      <b-form-radio v-bind:value="1">CENTCOM</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="selectedRequestTypeId >= 3 && selectedRequestTypeId <= 4" class="mb-2">
              <b-col>
                  <b-form-group id="notificationSubmit">
                    <label for="notificationSubmit">Where would you like the notification be submitted?</label>
                    <b-form-radio-group v-model="selectedSubmissionId">
                      <b-form-radio v-bind:value="0">EHOC</b-form-radio>
                      <b-form-radio v-bind:value="1">CENTCOM</b-form-radio>
                      <b-form-radio v-bind:value="2" v-if="selectedRequestTypeId == 3">EHOC and CENTCOM</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="selectedSubmissionId > 0 && (selectedRequestTypeId == 1 || (selectedRequestTypeId >= 3 && selectedRequestTypeId <= 4))" class="mb-2">
              <b-col>
                  <b-form-group id="notificationSubmit">
                    <label for="selectedCentcomConsentId">Do you provide consent to share the notification with CENTCOM?</label>
                    <b-form-radio-group v-model="selectedCentcomConsentId">
                      <b-form-radio v-bind:value="true">Yes</b-form-radio>
                      <b-form-radio v-bind:value="false">No</b-form-radio>                    
                    </b-form-radio-group>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('selectedCentcomConsentId') }}</small> 
                  </b-form-group>
              </b-col>            
            </b-row>

            <b-row v-if="selectedSubmissionId > 0 && (selectedRequestTypeId == 1 || (selectedRequestTypeId >= 3 && selectedRequestTypeId <= 4))" class="mb-2">
              <b-col>
                  <b-form-group id="selectedOrgAnonymousId">
                    <label for="selectedOrgAnonymousId">Do you want organization to be anonymous?</label>
                    <b-form-radio-group v-model="selectedOrgAnonymousId">
                      <b-form-radio v-bind:value="true">Yes</b-form-radio>
                      <b-form-radio v-bind:value="false">No</b-form-radio>                    
                    </b-form-radio-group>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('selectedOrgAnonymousId') }}</small>
                  </b-form-group>
              </b-col> 
            </b-row>

           <!--  <b-row>
                <b-col >
                  <b-form-group class="mb-0" v-if="selectedRequestTypeId > 1 && selectedRequestTypeId != 4">
                    <label for="currentTime">Please select current date/time</label>
                    <datepicker format="DD/MM/YYYY HH:mm:ss"
                        v-model="currentTime" 
                        :local="local" 
                        :disabled-date="disabledDate" 
                        @input="validateDate"/>                        
                  </b-form-group>
               </b-col>               
            </b-row> -->
            
            <b-row>
                <b-col >
                  <b-form-group class="mb-0" v-if="selectedRequestTypeId > 1 && selectedRequestTypeId != 4">
                    <label for="selectedDate">Please select the start date of the notification</label>
                    <datepicker format="DD/MM/YYYY"
                        v-model="selectedDate" 
                        :local="local" 
                        :disabled-date="disabledDate" 
                        @input="validateDate"/>  <br>                        
                        <small class="text-danger font-weight-bold">{{ validation.firstError('selectedDate') }}</small>
                  </b-form-group>
               </b-col>               
            </b-row>

            <b-row v-if="selectedRequestTypeId > 1 && selectedRequestTypeId != 4">
              <b-col>
                <small>Total hours before movement: {{totalHours}} hrs</small><br>
                <small>Movement start date: {{ startDateMovement | formatDate('DD/MM/YYYY HH:mm') }}</small><br>
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="selectedRequestTypeId > 1 && selectedRequestTypeId != 4">
              <b-col>
                  <!-- <small class="text-danger font-weight-bold" v-if="cutoffTime">Cut-off time is already passed.  Your request will be process on the next working day.</small><br> -->
                  <!-- <small class="text-danger font-weight-bold" v-if="cutoffTime">Cut-off time is already passed.  Please submit your notification tomorrow.</small><br> -->
                  <small class="text-muted"><b>IMPORTANT</b>: Please be informed that the cut-off time for submission during weekdays (Sunday - Thursday) is 09:00 - 14:00 and during weekends (Friday - Saturday) is 10:00 - 13:00. Notifications and <b>amendments</b> submitted outside of the cut-off time will be processed the next day.<br><br>
                  The hour counter tool is set to display the countdown of hours based on your selected start date and time, this is to help you adhere to the notification procedures and requirements (48 Hours Plus the NLT working hours).
                  </small><br><br>

                  <i class="fa fa-lightbulb-o text-warning fa-1x"></i> 
                  <small class="text-muted">For ships please enter arrival date to the port in Yemen</small>
               </b-col>
            </b-row>
            
            <b-row>
                <b-col>
                  <!-- <div v-if="emergencyNotificationList && emergencyNotificationList.length > 0"> -->
                  <div v-if="lessThan48Hours">
                    <b-form-group>
                      <label for="country">Please select the type of emergency notification</label>
                      <b-form-select ref="selectEmergency" class="col-8"
                        v-model="selectedEmergencyId"
                        @change="changeEmergencyEventHandler">
                        <template slot="first">
                              <option :value="null" disabled>-- Please select an option --</option>
                        </template>
                        <option v-for="item in emergencyNotificationList" :value="item.id" :title="item.tooltip">
                          {{ item.description }}
                        </option>
                      </b-form-select>                     
                      <small class="text-danger font-weight-bold">{{ validation.firstError('selectedEmergencyId') }}</small><br>
                    </b-form-group>
                  </div>
                </b-col>
            </b-row>

            <!-- <div v-if="selectedEmergencyId === 1 || selectedEmergencyId === 5 || selectedEmergencyId === 6 || selectedEmergencyId === 7 || selectedEmergencyId === 8|| selectedEmergencyId === 9">
              <b-row class="mb-2">
                  <b-col class="col-6">
                      <label for="nvNumber">Notification #</label>
                      <b-input-group>                          
                          <b-form-input ref="nvNumber" type="text" 
                                        v-model="nvNumber"
                                        placeholder="Enter Notification #">
                          </b-form-input> 
                          <b-input-group-append>
                            <b-button variant="secondary" @click="searchNVNumber"><i class="fa fa-search"></i></b-button>
                          </b-input-group-append>                          
                      </b-input-group>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('nvNumber') }}</small>
                  </b-col>
                  <b-col class="col-6 mb-2">
                      <label for="status">Status</label>
                      <b-input-group>                          
                          <b-form-select :value="selectedStatusId" :options="statusList" text-field="name" value-field="id" @change="statusChangeEventHandler" disabled/>                          
                      </b-input-group>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('selectedStatusId') }}</small>
                  </b-col>
              </b-row>              
            </div> -->

            <!-- <div v-if="selectedEmergencyId === 1 || selectedEmergencyId === 2 || selectedEmergencyId === 3 || selectedEmergencyId === 4 || selectedEmergencyId === 5 || selectedEmergencyId === 7 || selectedEmergencyId === 8 || selectedEmergencyId === 9 || selectedEmergencyId === 10 || selectedEmergencyId === 11 || (selectedEmergencyId >= 13 && selectedEmergencyId <= 16)"> -->
            <div v-if="selectedRequestTypeId === 2 || selectedRequestTypeId === 3 || selectedRequestTypeId === 5 || selectedRequestTypeId === 6">
              <b-row v-if="lessThan48Hours">
                    <b-col>
                      <b-form-group>
                            <!-- <label v-if="selectedEmergencyId === 1 || selectedEmergencyId === 9">Describe the change in deconfliction</label>
                            <label v-if="selectedEmergencyId === 2 || selectedEmergencyId === 3 || selectedEmergencyId === 4 || selectedEmergencyId === 10 || selectedEmergencyId === 11 || (selectedEmergencyId >= 13 && selectedEmergencyId <= 16)">Describe the urgent of movement</label> 
                            <label v-if="selectedEmergencyId === 5">Describe the change in the flight details and the reason for the changes</label>                            
                            <label v-if="selectedEmergencyId === 7">Describe the change in the vessel's details and the reason for the changes</label>
                            <label v-if="selectedEmergencyId === 8">Add the name and agency of the added passengers</label> -->
                            <label>Describe the urgent of movement</label> 
                            <b-form-textarea 
                               id="notes"
                               ref="notesCase"
                               v-model="notes"
                               placeholder=""
                               :rows="3"
                               :max-rows="6">
                            </b-form-textarea>
                            <small class="text-danger font-weight-bold">{{ validation.firstError('notes') }}</small>
                      </b-form-group>
                    </b-col>
                </b-row>       
            </div> 

            <div v-if="selectedEmergencyId === 3">
               <b-row v-if="lessThan48Hours">
                  <b-col>
                    <b-alert show variant="warning">                     
                      <small class="text-muted mb-0">
                        <p align="justify"><i class="fa fa-info-circle text-primary fa-1x"></i>&nbsp;&nbsp;Ambulances do not need deconfliction as long as they are properly identified as a medical vehicle (including marking and flash light).<br><br>
                        <i class="fa fa-file-pdf-o text-primary fa-1x"></i>&nbsp; <a href="#" @click="viewPDF">Deconfliction Rules and Procedures</a></p>
                      </small>                      
                    </b-alert>
                  </b-col>
               </b-row>
            </div>

            <div v-if="emergencyNotificationList && emergencyNotificationList.length > 0">
              <b-row>
                  <b-col>
                    <b-form-group class="mb-0" v-if="lessThan48Hours">
                      <b-form-checkbox v-model="managementAlerted">
                        Confirm if OCHA senior management have been alerted?
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
              </b-row>  
            </div>

           <!--  <div v-if="selectedEmergencyId === 6 || selectedEmergencyId === 8">
               <br>
               <b-row>
                  <b-col>va
                    <b-form-group>
                      <label>Please upload passport copies, visa copies, and any other related documents.</label>
                      <b-button :disabled="!isUploadReady" variant="primary" v-b-modal.uploadModal v-b-modal.modal-center size="sm"><i class="fa fa-upload"></i> Upload document</b-button>    
                    </b-form-group>
                  </b-col>
               </b-row>
            </div> -->
  
          </b-form>
        </b-col>
      </b-row>
    </b-modal>  
    <!--// MODAL Notification Request -->

    <!--// MODAL EDIT Notification Request CENTCOM -->   
     <b-modal centered ref="editNotifRequestCentcomModal" :title="'Notification #'+ selectedNotificationId" class="modal-primary" id="editNotifRequestCentcomModal" @ok="submitEditCentcomRequestEventHandler"> <!-- :ok-disabled="cutoffTime" -->
      <b-row>
        <b-col sm="12">
          <b-form>
            <b-row class="mb-3">
                <b-col>
                  <b-form-group class="mb-0" v-if="requestTypeList">
                    <label for="country">Please select the type of notification you want to request</label>
                    <b-form-select
                          ref="requestTypeButton"
                          :disabled="disabledRequestType"
                          class="col-8"
                          v-model="selectedRequestTypeId"
                          :options="requestTypeList" 
                          text-field="description" 
                          value-field="id" 
                          @change="requestTypeEventHandler">
                        <template slot="first">
                            <option :value="null" disabled>-- Please select an option --</option>
                        </template>
                    </b-form-select>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('selectedRequestTypeId') }}</small>
                  </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="selectedRequestTypeId == 1" class="mb-2">
              <b-col>
                  <b-form-group id="notificationSubmit">
                    <label for="notificationSubmit">Select submission type for this amendment?</label>
                    <b-form-radio-group v-model="selectedSubmissionId">
                      <b-form-radio v-bind:value="0">EHOC</b-form-radio>
                      <b-form-radio v-bind:value="1">CENTCOM</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="selectedRequestTypeId >= 3 && selectedRequestTypeId <= 4" class="mb-2">
              <b-col>
                  <b-form-group id="notificationSubmit">
                    <label for="notificationSubmit">Where would you like the notification be submitted?</label>
                    <b-form-radio-group v-model="selectedSubmissionId">
                      <b-form-radio v-bind:value="0">EHOC</b-form-radio>
                      <b-form-radio v-bind:value="1">CENTCOM</b-form-radio>
                      <b-form-radio v-bind:value="2" v-if="selectedRequestTypeId == 3">EHOC and CENTCOM</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="selectedSubmissionId > 0 && (selectedRequestTypeId == 1 || (selectedRequestTypeId >= 3 && selectedRequestTypeId <= 4))" class="mb-2">
              <b-col>
                  <b-form-group id="notificationSubmit">
                    <label for="selectedCentcomConsentId">Do you provide consent to share the notification with CENTCOM?</label>
                    <b-form-radio-group v-model="selectedCentcomConsentId">
                      <b-form-radio v-bind:value="true">Yes</b-form-radio>
                      <b-form-radio v-bind:value="false">No</b-form-radio>                    
                    </b-form-radio-group>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('selectedCentcomConsentId') }}</small> 
                  </b-form-group>
              </b-col>            
            </b-row>

            <b-row v-if="selectedSubmissionId > 0 && (selectedRequestTypeId == 1 || (selectedRequestTypeId >= 3 && selectedRequestTypeId <= 4))" class="mb-2">
              <b-col>
                  <b-form-group id="selectedOrgAnonymousId">
                    <label for="selectedOrgAnonymousId">Do you want organization to be anonymous?</label>
                    <b-form-radio-group v-model="selectedOrgAnonymousId">
                      <b-form-radio v-bind:value="true">Yes</b-form-radio>
                      <b-form-radio v-bind:value="false">No</b-form-radio>                    
                    </b-form-radio-group>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('selectedOrgAnonymousId') }}</small>
                  </b-form-group>
              </b-col> 
            </b-row>

          </b-form>
        </b-col>
      </b-row>
    </b-modal>  
    <!--// MODAL Edit Notification Request CENTCOM -->

    <!--// MODAL Upload Document -->   
     <b-modal centered ref="uploadModal" title="Upload Documents" class="modal-primary" id="uploadModal" @cancel="cancelUploadEventHandler" ok-title="Done" @ok="doneUploadEventHandler">
      <b-row>
        <b-col sm="12">
          <b-form>
             <b-row>
                <b-col>
                  <b-alert :show="showUploadAlert"
                           dismissible
                           variant="warning">
                      <strong>Upload completed!</strong> You successfully upload the file.
                  </b-alert>
                  <b-form>
                    <file-upload
                          ref='fileUpload'
                          title='Please enter description of the file into the description field and click "Browse" to select a file from your local computer.  When ready, click "Start Upload" to start uploading the file.'
                          @event-handler="fileUploadEventHandler($event)">            
                    </file-upload>
                  </b-form>
                </b-col>
             </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>  
    <!--// MODAL Upload Document -->

  </div>
</template>

<script>
import * as utils from '@/mixins/utils'
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import NotificationService from '@/api/NotificationService'
import LandMovementService from '@/api/LandMovementService'
import TempVenueService from '@/api/TempVenueService'
import SeaService from '@/api/SeaService'
import AirService from '@/api/AirService'
import NSLService from '@/api/NSLService'
import UploadService from '@/api/UploadService'
import { mapGetters } from 'vuex';
import UserSubmittedChart from '@/components/dashboard/UserSubmittedChart'
import UserApprovedChart from '@/components/dashboard/UserApprovedChart'
import UserCancelledChart from '@/components/dashboard/UserCancelledChart'
import UserPendingChart from '@/components/dashboard/UserPendingChart'

import DashboardChart from '@/components/dashboard/DashboardChart'

import CardLine1ChartExample from '@/components/dashboard/CardLine1ChartExample'
import CardLine2ChartExample from '@/components/dashboard/CardLine2ChartExample'
import CardLine3ChartExample from '@/components/dashboard/CardLine3ChartExample'
import CardBarChartExample from '@/components/dashboard/CardBarChartExample'
import MainChartExample from '@/components/dashboard/MainChartExample'
import RequestTable from '@/components/user/Table.vue'
import FileUpload from '@/components/file-upload/FileUpload'
import toast from '@/mixins/toast'
import userDashboardMixin from '@/mixins/validators/UserDashboard-validators'

export default {
  name: 'dashboard',    
  components: {
    UserSubmittedChart,
    UserApprovedChart,
    UserCancelledChart,
    UserPendingChart,    
    DashboardChart,
    RequestTable,
    FileUpload
  },
  mixins: [
    userDashboardMixin
  ],
  created () {
      this.$store.dispatch(types.ACTION_DASHBOARD_STATISTICS, this.$store.state.agencyId)      
  },
  data: () => {
      return {
        //currentTime: null,
        selectedNotificationId: null,
        selectedSubmissionId: 0,
        selectedCentcomConsentId: null,
        selectedOrgAnonymousId: null,
        selectedRequestTypeId: null,
        selectedEmergencyId: null,
        selectedDate: null,
        startDateMovement: null,
        selectedStatusId: null,
        managementAlerted: false,
        lessThan48Hours: false,
        isUploadReady: false,
        otherEmergency: null,
        nvNumber: null,
        status: null,
        notes: null,
        showUploadAlert: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        emergencyType: null,
        emergencyDescription: null,
        cutoffTime: false,
        nextWorkingDate: null,
        totalHours: 0,
        disabledRequestType: false,
        local: constants.DATE_LOCALE_EN
      }
  },
  computed: {
    ...mapGetters({ 
      requestTypeList: types.GET_REQUEST_TYPES,
      emergencyNotificationList: types.GET_EMERGENCY_NOTIFICATION,
      statusList: types.GET_STATUSES,
      statistics: types.GET_DASHBOARD_STATISTICS
    })
  },
  methods: {  

    eventHandler(e) {
        console.log("** eventHandler **")
        console.log(e)  
        console.log("requestTypeId: "+ e.item.request_type_id)
        this.init()        
        this.disabledRequestType = true
        this.selectedNotificationId = e.item.id
        this.selectedRequestTypeId = e.item.request_type_id
        this.selectedSubmissionId = 0
        this.selectedCentcomConsentId = e.item.centcom_consent.toUpperCase() == 'YES' ? true : false 
        this.selectedOrgAnonymousId = e.item.org_anonymous.toUpperCase() == 'YES' ? true : false

        // check for notificaiton recipient
        if (e.item.notification_recipient === 'CENTCOM')
            this.selectedSubmissionId = 1
        else if (e.item.notification_recipient === 'EHOC and CENTCOM')
            this.selectedSubmissionId = 2


        if (e.action === 'copy-notification') {
            this.$store.dispatch(types.ACTION_FIND_EMERGENCY_NOTIFICATION, this.selectedRequestTypeId)
            this.$refs.requestModal.show()  
        }
        else if (e.action === 'edit-notification') {
            this.$refs.editNotifRequestCentcomModal.show()
        }
        
    },

    getColor: function(value) {
      let obj = this.$_.find(constants.STATUS_COLOR_CODES, {id:value})
      return obj ? obj.color : "#84ffff" ;
    },  

    init() {
      this.currentTime = null
      this.cutoffTime = false
      this.isUploadReady = false
      this.nvNumber = null
      this.status = null
      this.notes = null
      this.lessThan48Hours = false
      this.selectedRequestTypeId = null
      this.selectedSubmissionId = 0
      this.selectedCentcomConsentId = null
      this.selectedDate = null
      this.selectedEmergencyId = null
      this.validation.reset()
      this.showUploadAlert = false  
      this.totalHours = 0    
      this.disabledRequestType = false
    },     
    doneUploadEventHandler() {      
      this.$refs.requestModal.show()
    },
    cancelUploadEventHandler() {
      this.$refs.requestModal.show()
    },
    viewPDF() {
      let baseUrl = window.location.origin
      let pdfWindow = window.open(baseUrl + '/static/pdf/deconfliction_reminder.pdf', '_blank', 'fullscreen=no,width=600,height=600')
      pdfWindow.moveTo(100, 200);
    },
    searchNVNumber() {
        const $this = this
        if (this.nvNumber) {
            NotificationService.fetchByNotificationIdAndRequestTypeId(this.nvNumber, this.selectedRequestTypeId).then( (resp) => {
              if (resp) {
                  $this.selectedStatusId = resp.status_id
                  $this.isUploadReady = true                  
              } 
              else {              
                $this.selectedStatusId = 0
                $this.isUploadReady = false
                toast.error("No matching record found for Notification #"+ $this.nvNumber , "Not found")
              }
            })
        }
    },
    disabledDate (time) {
      var yesterday = this.$moment().toDate()
      yesterday.setDate(yesterday.getDate() - 1);
      
      return time < yesterday
    },
    changeEmergencyEventHandler(e) {
      let obj = this.$_.find(this.emergencyNotificationList, {id: e});
      this.emergencyType = obj.description

      this.validation.reset()
      // if (e == 1 || e == 5) {          
      //     setTimeout(function () {
      //       this.$refs.nvNumber.$el.focus()
      //     }.bind(this), 300) 
      // }
      // else 
      if (e == 2 || e == 3 || e == 4) {
          setTimeout(function () {
            this.$refs.notesCase.$el.focus()
          }.bind(this), 300) 
      }
    },
    statusChangeEventHandler(e) {
      this.selectedStatusId = e
    },
    requestTypeEventHandler(e) {
      this.selectedEmergencyId = null
      this.$store.dispatch(types.ACTION_FIND_EMERGENCY_NOTIFICATION, e)
    },
    submitRequestEventHandler(e) {
      e.preventDefault()

      let fields = ['selectedRequestTypeId']

      if (this.lessThan48Hours) {
          if (this.selectedRequestTypeId == constants.FORM_AIR ||
                  this.selectedRequestTypeId == constants.FORM_LAND_MOVEMENT || 
                  this.selectedRequestTypeId == constants.FORM_SEA || 
                  this.selectedRequestTypeId == constants.FORM_TEMP_VENUE) {
              fields = ['selectedRequestTypeId','selectedDate','selectedEmergencyId','notes']
          }  
      }
      else {

          if (this.selectedRequestTypeId == constants.FORM_ADMIN_LETTERS) {
              fields = ['selectedRequestTypeId']
          }
          else if (this.selectedRequestTypeId == constants.FORM_AIR ||
                   this.selectedRequestTypeId == constants.FORM_LAND_MOVEMENT || 
                   this.selectedRequestTypeId == constants.FORM_SEA || 
                   this.selectedRequestTypeId == constants.FORM_TEMP_VENUE) {

                   fields = ['selectedRequestTypeId','selectedDate']
          }  
      }


      if (this.selectedSubmissionId > 0 && (this.selectedRequestTypeId == 1 || (this.selectedRequestTypeId >= 3 && this.selectedRequestTypeId <= 4))) {
          fields.push('selectedCentcomConsentId');
          fields.push('selectedOrgAnonymousId');
      }

      const $this = this
      this.$validate(fields)
          .then(function(success) {
            if (success) {
                
                $this.$refs.requestModal.hide()

                
                // if disabledRequestType is true execute copy action
                if ( $this.disabledRequestType ) {

                    console.log('** copy execute here! **')

                    let payload = {
                        id: $this.selectedNotificationId,
                        start_date: $this.$moment($this.startDateMovement).format('YYYY-MM-DDTHH:mm:ssZ'),
                        emergency_type: $this.emergencyType,
                        emergency_description: $this.notes,
                        ocha_alerted: $this.managementAlerted,
                        last_update: $this.$moment().format(),
                        submission_id: $this.selectedSubmissionId,
                        centcom_consent: $this.selectedCentcomConsentId,
                        org_anonymous: $this.selectedOrgAnonymousId
                    }

                    NotificationService.copyNotificationRequest(payload).then( (resp) => {
                        toast.success( "Notification #"+ resp.id +" has been created successfully.")
                        $this.$refs.table.refreshTable()
                    })

                    return false
                }

                let status = $this.$_.find($this.$store.state.statusList, {id: constants.STATUS_INUSE});
                let notes = $this.$moment().format('DD/MM/YYYY HH:mm') +'\n'+ status.name
                let currentDate = $this.$moment().format('YYYY-MM-DDTHH:mm:ssZ')

                
                // save new notification
                let payload = {
                      id: 0,
                      agency_id: $this.$store.state.agencyId,
                      requested_date: currentDate,
                      request_type_id: $this.selectedRequestTypeId,
                      requested_by: $this.$store.state.userId,
                      purpose_id: 0,
                      purpose_others: null,
                      route_map_terrain: null,
                      route_map_satellite: null,
                      ehoc_ref: null,        
                      notes: notes,
                      last_update: currentDate,
                      last_updated_by: $this.$store.state.userId,
                      status_id: constants.STATUS_INUSE,
                      submission_id: $this.selectedSubmissionId,
                      centcom_consent: $this.selectedCentcomConsentId,
                      org_anonymous: $this.selectedOrgAnonymousId
                }

                NotificationService.addNotification(payload).then( (response) => {
                    console.log("********************")
                    console.log(response)
                    console.log("********************")

                    if (response) {
                          const notificationId = response.id
                          const requestTypeId = $this.selectedRequestTypeId
                          const orgAnonymous = response.org_anonymous && response.org_anonymous.toLowerCase() === "yes";
                          const submittedId = response.submission_id;

                          // store notification into state
                          $this.$store.commit(types.MUTATE_NOTIFICATION_ID, notificationId)
                          $this.$store.commit(types.MUTATE_MODIFIED, false)
                          $this.$store.commit(types.MUTATE_NEW_NOTIFICATION, true)
                          $this.$store.commit(types.MUTATE_ORG_ANONYMOUS, orgAnonymous)
                          $this.$store.commit(types.MUTATE_SUBMITTED_ID, submittedId)

                          $this.loadNotification(notificationId)

                          if (requestTypeId === constants.FORM_LAND_MOVEMENT) {
                                $this.loadLandMovement(notificationId) 
                          }
                          else if (requestTypeId === constants.FORM_TEMP_VENUE) {
                                $this.loadTempVenue(notificationId) 
                          }
                          else if (requestTypeId === constants.FORM_SEA) {
                                $this.loadSea(notificationId) 
                          }
                          else if (requestTypeId === constants.FORM_AIR) {
                                $this.loadAir(notificationId)
                          }
                          else if (requestTypeId === constants.FORM_NO_STRIKE_LIST) {
                                $this.loadNSL(notificationId) 
                          }   
                          else if (requestTypeId === constants.FORM_ADMIN_LETTERS) {
                                 $this.loadAdminLetters()
                          }

                          if (requestTypeId === constants.FORM_LAND_MOVEMENT || 
                              requestTypeId === constants.FORM_TEMP_VENUE ||
                              requestTypeId === constants.FORM_SEA ||
                              requestTypeId === constants.FORM_AIR) { 
                              setTimeout(function () { 
                                  $this.saveNotificationRequest(notificationId)
                              }.bind(this), 300)   
                          }
                    }
                    else {
                      console.log(response)
                    }          
                })
                     
            }
      })
    },

    submitEditCentcomRequestEventHandler(e) {
      e.preventDefault()

      let fields = ['selectedRequestTypeId']
      if (this.selectedSubmissionId > 0 && this.selectedRequestTypeId == 1 || this.selectedRequestTypeId >= 3 && this.selectedRequestTypeId <= 4) {
          fields.push('selectedCentcomConsentId');
          fields.push('selectedOrgAnonymousId');
      }

      if (this.selectedSubmissionId === 0) {
          this.selectedCentcomConsentId = false
          this.selectedOrgAnonymousId = false
      }

      const $this = this
      this.$validate(fields)
          .then(function(success) {
            if (success) {
                
                $this.$refs.editNotifRequestCentcomModal.hide()

                let status = $this.$_.find($this.$store.state.statusList, {id: constants.STATUS_INUSE});
                let notes = $this.$moment().format('DD/MM/YYYY HH:mm') +'\n'+ status.name
                let currentDate = $this.$moment().format('YYYY-MM-DDTHH:mm:ssZ')

                // update notification for CENTCOM
                let payload = {
                    id: $this.selectedNotificationId,
                    last_update: $this.$moment().format(),
                    last_updated_by: $this.$store.state.userId,
                    submission_id: $this.selectedSubmissionId,
                    centcom_consent: $this.selectedCentcomConsentId,
                    org_anonymous: $this.selectedOrgAnonymousId
                }

                // toast.success( "Notification #"+ payload.id +"\nsubmission_id: "+ payload.submission_id +"\ncentcom_consent: "+ payload.centcom_consent +"\norg_anonymous: "+ payload.org_anonymous +" has been updated successfully.")

                NotificationService.updateNotificationRequestCentcom(payload).then( (resp) => {
                    toast.success( "Notification #"+ resp.id +" has been updated successfully.")
                    $this.$refs.table.refreshTable()
                })
            }
      })

    },

    saveNotificationRequest(notificationId) {

        // let startDate = this.$moment(this.selectedDate).tz('Asia/Riyadh').format('YYYY-MM-DDT06:00:00ZZ')
        // if (this.cutoffTime) {
        //     startDate = this.$moment(this.nextWorkingDate).tz('Asia/Riyadh').format('YYYY-MM-DDT06:00:00ZZ')        
        // }
        // 
        // let startDate = this.$momenttz(this.startDateMovement).tz("Asia/Riyadh")
        
        console.log("** saveNotifications **")
        console.log(this.$moment(this.startDateMovement).format('YYYY-MM-DDTHH:mm:ssZ'))

        let payload = {
            id: notificationId,
            start_date: this.$moment(this.startDateMovement).format('YYYY-MM-DDTHH:mm:ssZ'),
            emergency_type: this.emergencyType,
            emergency_description: this.notes,
            ocha_alerted: this.managementAlerted,            
            last_update: this.$moment().format()
        } 

        // console.log("**** payload ****")
        // console.log(payload)

        // update notification request
        this.$store.dispatch(types.ACTION_UPDATE_NOTIFICATION_REQUEST, payload)
    },

    loadNotification(notificationId) {
       // get notification
       NotificationService.fetchByNotificationIdAndRequestTypeId(notificationId, this.selectedRequestTypeId).then( (resp) => {
          this.$store.commit(types.MUTATE_MODE, constants.MODE_EDIT)
          this.$store.commit(types.MUTATE_NOTIFICATION_ID, resp.id)
          this.$store.commit(types.MUTATE_USER_AGENCY_ID, resp.agency_id)
          this.$store.commit(types.MUTATE_PURPOSE_ID, resp.purpose_id)
          this.$store.commit(types.MUTATE_PURPOSE_OTHERS, resp.purpose_others)
          this.$store.commit(types.MUTATE_DETAILS_NOTIFICATION, resp.details_notification)
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id)
          this.$store.commit(types.MUTATE_MAP, {roadmap: resp.route_map_terrain, satellite: resp.route_map_satellite})          
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id)
          this.$store.commit(types.MUTATE_EHOC_REF, resp.ehoc_ref)
          this.$store.commit(types.MUTATE_CENTCOM_REF, resp.centcom_ref)
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id) 
          this.$store.commit(types.MUTATE_REQUESTED_DATE, resp.request_date) 
          this.$store.commit(types.MUTATE_REQUESTED_BY, resp.requested_by)
          this.$store.commit(types.MUTATE_LAST_UPDATED_BY, resp.last_updated_by) 
          this.$store.commit(types.MUTATE_STATUS_ID, resp.status_id)
          this.$store.commit(types.MUTATE_START_DATE, resp.start_date)
          this.$store.commit(types.MUTATE_NOTES, resp.notes)
          this.$store.commit(types.MUTATE_ORG_ANONYMOUS, resp.org_anonymous)          
       }) 
    },
    loadLandMovement(notificationId) {
      
       // get waypoints
       LandMovementService.getWaypoints(notificationId).then( (resp) => {
          if (resp) {
             this.$store.commit(types.MUTATE_WAYPOINTS, resp)
          }          
       })

       // get convoys 
       LandMovementService.getConvoys(notificationId).then( (resp) => {    
          if (resp) {
             this.$store.commit(types.MUTATE_CONVOYS, resp)
          }  
       })

       // get participants 
       LandMovementService.getParticipants(notificationId).then( (resp) => {        
          if (resp) {
              this.$store.commit(types.MUTATE_PARTICIPANTS, resp)
          }
       })

       // get vehicles 
       LandMovementService.getVehicles(notificationId).then( (resp) => {        
          if (resp) {
            this.$store.commit(types.MUTATE_VEHICLES, resp)
          }
       })

       // get trucks 
       LandMovementService.getTrucks(notificationId).then( (resp) => {        
          if (resp) {
            this.$store.commit(types.MUTATE_TRUCKS, resp)
          }
       })

       // get photos 
       LandMovementService.getPhotos(notificationId).then( (resp) => {        
          if (resp) {
            this.$store.commit(types.MUTATE_PHOTOS, resp)
          }
       })

       // load land movement form
       this.$router.replace('/forms/land-movement')

    },
    loadTempVenue(notificationId) {

       TempVenueService.fetchByNotificationId(notificationId).then( (resp) => {
          if (resp) {
              this.$store.commit(types.MUTATE_VENUES, resp)
          }          
       })

        // temp venue
       this.$router.replace('/forms/temp-venue')
    },
    loadSea(notificationId) {

       SeaService.fetchByNotificationId(notificationId).then( (resp) => {
          if (resp) {
              this.$store.commit(types.MUTATE_SEA, resp)   
          }
       })

       // sea
       this.$router.replace('/forms/sea-movement')
    },
    loadAir(notificationId) {

       AirService.fetchByNotificationId(notificationId).then( (resp) => {
          if (resp) {
              this.$store.commit(types.MUTATE_AIR, resp)
          }          
       })

       // air
       this.$router.replace('/forms/air-movement')
    },
    loadNSL(notificationId) {

       NSLService.fetchByNotificationId(notificationId).then( (resp) => {
          if (resp) {
            this.$store.commit(types.MUTATE_NSL, resp)
          }
       })
       // NSL
       this.$router.replace('/forms/no-strike-list')
    },
    loadAdminLetters() {
        this.$router.replace('/forms/admin-letters')
    },
    
    validateDate(e) {
      let currentTime = this.$moment()
      //let currentTime = this.currentTime

      var dCurrentTime = this.$moment(currentTime, 'YYYY-MM-DD HH:mm')
      var temp = this.$moment(currentTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD 09:00')
      let dStartTime = this.$moment(temp)
      var selectedDate = this.selectedDate

      temp = this.$moment(selectedDate, 'DD/MM/YYYY').format('YYYY-MM-DD '+ dCurrentTime.format('HH:mm')) 
      let dStartDate = this.$moment(temp, 'YYYY-MM-DD HH:mm')

      
      temp = this.$moment(dCurrentTime, 'DD/MM/YYYY 16:30:00').format('YYYY-MM-DD 16:30:00')
      let cutoffDate = this.$moment(temp, 'YYYY-MM-DD HH:mm')

      let duration = 0 
      let hours = 0 
      let days = 0 

       // submitted after 4:30pm
      if ( dCurrentTime.isAfter(cutoffDate) ) {

            temp = this.$moment(dCurrentTime).add(1, 'day').format('YYYY-MM-DD 09:00')
            let dNextWorkingDay = this.$moment(temp).format('YYYY-MM-DD 09:00')      
            
            duration = this.$moment.duration(dStartDate.diff(dNextWorkingDay))
            hours = duration.asHours().toFixed(1)
            days =  duration.asDays().toFixed(1)

            console.log("days: "+ days)
            console.log("hours: "+ hours)
            console.log("dCurrentTime: "+ dCurrentTime.format())
            console.log("dStartDate: "+ dStartDate.format())
            
            console.log("cutoffDate: "+ cutoffDate.format())
            console.log("Note: Submitted after 4:30pm")
      }
      // submitted before 9:00am
      else if ( dCurrentTime.isBefore(dStartTime)  ) {
          
          console.log("dStartTime: "+ dStartTime.format())
          console.log("dStartDate: "+ dStartDate.format())

          duration = this.$moment.duration(dStartDate.diff(dStartTime))
          hours = duration.asHours().toFixed(1)
          days =  duration.asDays().toFixed(1)

          console.log("Note: Submitted before 9:00am")

      }
      // submitted between 9:00am - 4:30pm
      else if (dCurrentTime.isSameOrAfter(dStartTime) && dCurrentTime.isSameOrBefore(cutoffDate) ) {
          
          //let dDate50Hours = moment(dCurrentTime).add(50, 'hours')
          dStartDate = dStartDate.add(2, 'hours')

          console.log("dStartDate: "+ dStartDate.format())
          duration = this.$moment.duration(dStartDate.diff(dCurrentTime))
          hours = duration.asHours().toFixed(1)
          days =  duration.asDays().toFixed(1)

          //console.log("dDate50Hours: "+ dDate50Hours.format())
          console.log("Note: Submitted between 9:00am-4:30pm")
      }

      if ( hours < 50 ) {          
          temp = this.$moment(dStartDate).format('YYYY-MM-DD 09:00')
          dStartDate = this.$moment(temp)
      }
      else if (hours > 50) {
          console.log("** more than 50hrs")
          temp = this.$moment(dStartDate).format('YYYY-MM-DD 06:00')
          dStartDate = this.$moment(temp)
      }

      console.log("days: "+ days)
      console.log("hours: "+ hours)
      console.log("dCurrentTime: "+ dCurrentTime.format())
      console.log("dStartDate: "+ dStartDate.format())
      
      this.startDateMovement = dStartDate
      this.totalHours = hours
      this.lessThan48Hours = hours < 50

      // else {

      //     $("#movementDate").text(dStartDate.format('DD/MM/YYYY HH:mm'))
      //     $("#totalDays").text( (days > 1) ? days+" days" : days +" day")
      //     $("#totalHours").text(hours +" hrs")
      //     $("#notes").text("Normal")  

      // }
      // 
      // 

      // let duration = this.$moment.duration(dStartDate.diff(dCurrentTime))
      // let hours = Math.round(duration.asHours()) + 2
      // let days = Math.round(duration.asDays())

      // this.totalHours = hours

      // console.log("days: "+ days)
      // console.log("dCurrentTime: "+ dCurrentTime.format())
      // console.log("dStartDate: "+ dStartDate.format())
      // console.log("dStartTime: "+ dStartTime.format())
      // console.log("cutoffDate: "+ cutoffDate.format())


      // if (hours < 50) {
      //     // emergency
      //     let dDate50Hours =  dStartDate
      //     this.startDateMovement = dStartDate.format('YYYY-MM-DDTHH:mm:ssZ')
      //     this.totalHours = hours

      //     console.log("movementDate: "+ dStartDate.format('DD/MM/YYYY HH:mm'))
      //     console.log("hours: "+ this.totalHours)
      //     console.log("notes: Emergency")
      //     // $("#movementDate").text(dStartDate.format('DD/MM/YYYY HH:mm'))
      //     // $("#totalDays").text( (days > 1) ? days+" days" : days +" day")
      //     // $("#totalHours").text(hours +" hrs")
      //     // $("#notes").text("Emergency")
      // } 
      // else if (days == 2 && dCurrentTime.isSameOrAfter(dStartTime) && dCurrentTime.isSameOrBefore(cutoffDate) ) {

      //    temp = this.$moment(dCurrentTime, 'YYYY-MM-DD HH:mm')
      //    let dDate50Hours = this.$moment(temp).add(50, 'hours')
         
      //    duration = this.$moment.duration(dDate50Hours.diff(dCurrentTime))       
      //    hours = Math.round(duration.asHours())
      //    days = Math.round(duration.asDays())

      //    console.log("//**************************")
      //    console.log("hours: "+ hours)
      //    console.log("days: "+ days)
      //    console.log("**************************")

      //    temp = this.$moment(dStartDate, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD 16:30')
      //    let cutoffDate2 = this.$moment(temp, 'YYYY-MM-DD HH:mm')

      //    console.log("dStartDate: "+ dStartDate.format()) 
      //    console.log("cutoffDate2: "+ cutoffDate2.format())
      //    let durationFromCutoffTime = this.$moment.duration(dDate50Hours.diff(cutoffDate2))
         
      //    let hoursDiff = Math.round(durationFromCutoffTime.asHours())
      //    console.log("hoursDiff: "+ hoursDiff)

      //    if (dDate50Hours.isAfter(cutoffDate2)) {

      //        console.log("Movement passed cut-off date: "+ dDate50Hours.format() )
      //        temp = this.$moment(dDate50Hours).add(1, 'day')

      //        console.log("** added 1 day: "+ this.$moment(temp).format())
      //        let dNextWorkingDay = this.$moment(temp).format('YYYY-MM-DD 09:00')

      //        console.log("** dNextWorkingDay : "+ this.$moment(dNextWorkingDay).format())
      //        dDate50Hours = this.$moment(dNextWorkingDay).add(hoursDiff, 'hours')  
      //        console.log("** dDate50Hours : "+ this.$moment(dDate50Hours).format())
             
      //        duration = this.$moment.duration(dDate50Hours.diff(dCurrentTime))
      //        hours = Math.round(duration.asHours())
      //        days = Math.round(duration.asDays())

      //        this.startDateMovement = dDate50Hours.format('YYYY-MM-DDTHH:mm:ssZ')
      //        this.totalHours = hours 
      //        console.log("hours: "+ hours )
      //    }
      //    else {
      //        this.startDateMovement = dDate50Hours.format('YYYY-MM-DDTHH:mm:ssZ')
      //        this.totalHours = hours
      //    }

      //    // if (hoursDiff > 0) {
      //    //     dDate50Hours = this.$moment(temp).subtract(hoursDiff, 'hours')
      //    //     duration = this.$moment.duration(dDate50Hours.diff(dCurrentTime))
      //    //     hours = duration.asHours()
      //    //     days = duration.asDays().toFixed(2)

      //    //     console.log("//2**************************")
      //    //     console.log("hours: "+ hours)
      //    //     console.log("days: "+ days)
      //    //     console.log("**************************")
      //    // }

      //     // if (hours < 50) {
      //     //     // emergency    
      //     //     this.startDateMovement = dStartDate.format('DD/MM/YYYY HH:mm')
      //     //     this.totalHours = hours

      //     //     console.log("movementDate: "+ dStartDate.format('DD/MM/YYYY HH:mm'))
      //     //     console.log("hours: "+ this.totalHours)
      //     //     console.log("notes: Emergency - Movement passed the cut-off time at 16:30.")
      //     //     // $("#movementDate").text(dStartDate.format('DD/MM/YYYY HH:mm'))
      //     //     // $("#totalDays").text( (days > 1) ? days+" days" : days +" day")
      //     //     // $("#totalHours").text(hours +" hrs")
      //     //     // $("#notes").text("Emergency - Movement passed the cut-off time at 16:30.")
      //     // } 
      //     // else {
      //        // this.startDateMovement = dDate50Hours
      //        // this.hours = hours

      //        // console.log("movementDate: "+ dStartDate.format('DD/MM/YYYY HH:mm'))
      //        // console.log("hours: "+ this.totalHours)
      //        // console.log("notes: Normal - submitted between 09:00-16:30 period")

      //        // $("#movementDate").text(dDate50Hours.format('DD/MM/YYYY HH:mm'))
      //        // $("#totalDays").text( (days > 1) ? days+" days" : days +" day")
      //        // $("#totalHours").text(hours +" hrs")
      //        // $("#notes").text("Normal - submitted between 09:00-16:30 period")
      //      // }

      // }
      // else if (days === 2 && dCurrentTime.isAfter(cutoffDate) ) {
      //    // cut-off date is passed
      //    // 
      //         temp = this.$moment(dCurrentTime).add(1, 'day').format('YYYY-MM-DD 09:00')
      //         let dNextWorkingDay = this.$moment(temp).format('YYYY-MM-DD 09:00')      
      //         let dDate50Hours = this.$moment(dNextWorkingDay).add(50, 'hours')  
             
      //         duration = this.$moment.duration(dDate50Hours.diff(dCurrentTime))
      //         hours = Math.round(duration.asHours())
      //         days = Math.round(duration.asDays())

      //         this.startDateMovement = dDate50Hours.format('YYYY-MM-DDTHH:mm:ssZ')
      //         this.totalHours = hours

      //         console.log("movementDate: "+ dStartDate.format('DD/MM/YYYY HH:mm'))
      //         console.log("hours: "+ this.totalHours)
      //         console.log("Normal - submitted after 16:30pm will process next day")
             
      //         // $("#movementDate").text(dDate50Hours.format('DD/MM/YYYY HH:mm'))
      //         // $("#totalDays").text( (days > 1) ? days+" days" : days +" day")
      //         // $("#totalHours").text(hours +" hrs")
      //         // $("#notes").text("Normal - submitted after 16:30pm will process next day")
         
      // }
      // else if (days === 2 && dCurrentTime.isBefore(dStartTime) ) {
      //    // submitted before 09:00am
         
      //    temp = this.$moment(dStartTime, 'YYYY-MM-DD HH:mm')
      //    let dDate50Hours = this.$moment(temp).add(50, 'hours')
         
      //    duration = this.$moment.duration(dDate50Hours.diff(dCurrentTime))
      //    hours = Math.round(duration.asHours())
      //    days = Math.round(duration.asDays())

      //    this.startDateMovement = dDate50Hours.format('YYYY-MM-DDTHH:mm:ssZ')
      //    this.totalHours = hours

      //    console.log("movementDate: "+ dStartDate.format('DD/MM/YYYY HH:mm'))
      //    console.log("hours: "+ this.totalHours)
      //    console.log("Normal - submitted before 09:00am")
          
      //    // let type = (hours < 50) ? "Emergency" : "Normal" 
      //    // $("#movementDate").text(dDate50Hours.format('DD/MM/YYYY HH:mm'))
      //    // $("#totalDays").text( (days > 1) ? days+" days" : days +" day")
      //    // $("#totalHours").text(hours +" hrs")
      //    // $("#notes").text(type +" - submitted before 09:00am")
      // }    
      // else if (days >= 3) {

      //    temp = this.$moment(dCurrentTime).format('YYYY-MM-DD 06:00')
      //    let dDate50Hours = this.$moment(temp)
         
      //    duration = this.$moment.duration(dStartDate.diff(dCurrentTime))
      //    hours = Math.round(duration.asHours())
      //    days = Math.round(duration.asDays())

      //    this.startDateMovement = dDate50Hours.format('YYYY-MM-DDTHH:mm:ssZ')
      //    this.hours = hours

      //    console.log("movementDate: "+ dStartDate.format('DD/MM/YYYY HH:mm'))
      //    console.log("hours: "+ this.totalHours)
      //    console.log("notes: Normal - submitted "+ days +" days advance")
         
      //    // $("#movementDate").text(dDate50Hours.format('DD/MM/YYYY HH:mm'))
      //    // $("#totalDays").text( (days > 1) ? days+" days" : days +" day")
      //    // $("#totalHours").text(hours +" hrs")
      //    // $("#notes").text("Normal - submitted "+ days +" days advance")

      // }
      
      // const tz = constants.TZ_ASIA_RIYADH

      // let currentTime = this.$momenttz(this.$momenttz(),'YYYY-MM-DDT16:30:00').format('YYYY-MM-DDT16:30:00')      
      // currentTime = this.$moment(currentTime, 'YYYY-MM-DDTHH:mm')

      // let test = this.$moment(currentTime).add(50, 'hours')
      // console.log('test: '+ test.format('DD/MM/YYYY HH:mm'))

      // let selectedDate = this.$moment(this.selectedDate, 'YYYY-MM-DDTHH:mm')

      // console.log("currentTime: "+ currentTime.format())
      
      // //-- start
      // let dStartDate = this.$moment(selectedDate, 'YYYY-MM-DD HH:mm')     
      // let temp = this.$moment(currentTime).add(1, 'day').format('YYYY-MM-DDT09:00:00+03:00')
      // let dNextWorkingDay = this.$moment(temp).format('YYYY-MM-DDT09:00:00+03:00')

      // //temp = this.$momenttz(currentTime,'YYYY-MM-DDT09:00:00+03:00', tz).format('YYYY-MM-DDT09:00:00+03:00')      
      // temp = this.$momenttz(currentTime,'YYYY-MM-DDT09:00:00', tz).format('YYYY-MM-DDT09:00:00')      
      // let dStartTime = this.$moment(temp, 'YYYY-MM-DDTHH:mm')

      // let dDate50Hours = this.$moment(currentTime).add(50, 'hours')
      // let dRequestDate = this.$moment(currentTime, 'YYYY-MM-DD HH:mm')
      
      // var duration = this.$moment.duration(dDate50Hours.diff(currentTime))
      // var hours = Math.round(duration.asHours()) + 2
      // var days = Math.round(duration.asDays())

      // console.log("dStartDate: "+ dStartDate.format())
      // console.log("hours: "+ hours)
      // console.log("days: "+ days)
      // console.log("dStartDate.hour() "+ dStartDate.hour())
      // console.log("dStartTime: "+ dStartTime.format())
      // console.log("dStartTime.hour(): "+ dStartTime.hour())

      // //temp = this.$momenttz(dStartDate, 'DD/MM/YYYY 16:30:00+0300', tz).format('DD/MM/YYYY 16:30:00+0300')
      // temp = this.$momenttz(dStartDate, 'DD/MM/YYYY 16:30:00').format('DD/MM/YYYY 16:30:00')
      // var cutoffDate = this.$moment(temp, 'YYYY-MM-DD HH:mm')

      // // check if after cut-off time 16:30
      // let startDateHour = (dStartDate.hour() === 0) ? 24 : dStartDate.hour()
      // console.log("startDateHour = "+ startDateHour)
      // if (days === 2 && startDateHour >= cutoffDate.hour() && dStartDate.minutes() > cutoffDate.minutes() ) {         
      //        //console.log(startDateHour +" >= "+ cutoffDate.hour())
      //    //if (startDateHour >= cutoffDate.hour() && dStartDate.minutes() > cutoffDate.minutes() ) {
      //        console.log('cut-off time has passed, this will be process next working day.')
      //        temp = this.$moment(dNextWorkingDay).add(50, 'hours')
      //        dDate50Hours = this.$moment(temp)//.format('YYYY-MM-DDTHH:mm:ss+03:00')
      //        duration = this.$moment.duration(selectedDate.diff(currentTime))
      //        hours = Math.round(duration.asHours()) + 2
      //        days = Math.round(duration.asDays())

      //        console.log("Date 50 Hours: "+ dDate50Hours.format('YYYY-MM-DD HH:mm'))  
      //    //}         
      // } 
      // else if (days === 2 && startDateHour < dStartTime.hour() ) {
      //        console.log("Submitted before 9:00am")
      //        //var h = dStartTime.hour +2
      //        // temp = this.$momenttz(dStartDate, 'YYYY-MM-DDTHH:mm:ss+0300', 'Asia/Riyadh').format('YYYY-MM-DDT'+ h +':00:00+0300')
      //        // dDate50Hours = this.$moment(temp, 'YYYY-MM-DD HH:mm')              

      //        temp = this.$moment(dStartTime).add(50, 'hours')
      //        dDate50Hours = this.$moment(temp)//.format('YYYY-MM-DDTHH:mm:ss+03:00')            
      //        duration = this.$moment.duration(selectedDate.diff(currentTime))
      //        hours = Math.round(duration.asHours()) + 2
      //        days = Math.round(duration.asDays())

      //        // console.log("Date 50 Hours: "+ dDate50Hours.format('YYYY-MM-DD HH:mm'))             
      // }
      // else if (days == 2 && startDateHour >= dStartTime.hour() && startDateHour <= cutoffDate.hour() ) {
      //       console.log("** Normal **")

      //       temp = this.$momenttz(selectedDate,'YYYY-MM-DDT11:00:00+03:00', tz).format('YYYY-MM-DDT06:00:00+03:00')  
      //       temp = this.$moment(temp, 'YYYY-MM-DDTHH:00:00').format('YYYY-MM-DDT06:00:00')    

      //       temp = this.$moment(currentTime).add(50, 'hours')
      //       temp = this.$moment(temp, 'YYYY-MM-DDTHH:00:00').format('YYYY-MM-DDTHH:00:00')
      //       dDate50Hours = this.$moment(temp)

      //       duration = this.$moment.duration(selectedDate.diff(currentTime))
      //       hours = Math.round(duration.asHours()) + 2
      //       days = Math.round(duration.asDays())

      //       // if (hours >= 48 && hours <= 57) {                
      //       //     temp = this.$momenttz(dStartDate, 'YYYY-MM-DDTHH:mm:ss+0300', 'Asia/Riyadh').format('YYYY-MM-DDT11:00:00+0300')
      //       //     dDate50Hours = this.$moment(temp, 'YYYY-MM-DD HH:mm')              
      //       // } 
      //       // else {
      //       //     temp = this.$momenttz(dStartDate, 'YYYY-MM-DDTHH:mm:ss+0300', 'Asia/Riyadh').format('YYYY-MM-DDT06:00:00+0300')
      //       //     dDate50Hours = this.$moment(temp, 'YYYY-MM-DD HH:mm')              
      //       // }
            
      // }
      // else if (days >= 3) {
      //       console.log(">= 3 days **")
      //       temp = this.$momenttz(selectedDate,'YYYY-MM-DDT06:00:00+03:00', tz).format('YYYY-MM-DDT06:00:00+03:00')  
      //       temp = this.$moment(temp, 'YYYY-MM-DDTHH:00:00').format('YYYY-MM-DDT06:00:00')    
      //       //let dStartTime = this.$moment(temp, 'YYYY-MM-DDTHH:mm')

      //       //temp = this.$moment(dStartTime).add(50, 'hours')
      //       dDate50Hours = this.$moment(temp)
      //       duration = this.$moment.duration(selectedDate.diff(currentTime))
      //       hours = Math.round(duration.asHours()) + 2
      //       days = Math.round(duration.asDays())

      //       // if (hours >= 48 && hours <= 57) {                
      //       //     temp = this.$momenttz(dStartDate, 'YYYY-MM-DDTHH:mm:ss+0300', 'Asia/Riyadh').format('YYYY-MM-DDT11:00:00+0300')
      //       //     dDate50Hours = this.$moment(temp, 'YYYY-MM-DD HH:mm')              
      //       // } 
      //       // else {
      //       //     temp = this.$momenttz(dStartDate, 'YYYY-MM-DDTHH:mm:ss+0300', 'Asia/Riyadh').format('YYYY-MM-DDT06:00:00+0300')
      //       //     dDate50Hours = this.$moment(temp, 'YYYY-MM-DD HH:mm')              
      //       // }
            
      // }

      //-- end
      //
      // this.totalHours = hours
      // this.startDateMovement = dDate50Hours
      

      //console.log("           Current Date/Time: "+ this.$moment().format("DD/MM/YYYY HH:mm"))
      // console.log("           Current Date/Time: "+ this.$moment(currentTime).format("DD/MM/YYYY HH:mm"))
      // console.log("         Start Movement Date: "+ this.startDateMovement)
      // //console.log("            Next Working Day: "+ dNextWorkingDay)
      // console.log(" Total hours before movement: "+ this.totalHours)
      
      // const cutOffDate = this.$momenttz(selectedDate, 'DD/MM/YYYY 16:30:00ZZ', 'Asia/Riyadh').format('YYYY-MM-DDT16:30:00ZZ')
      
      // const hour = selectedDate.hour()
      // const minute = selectedDate.minute()
      
      // console.log("this.selectedDate: "+ this.selectedDate)
      // console.log("hour: "+ hour)
      // console.log("minute: "+ minute)

      // if (this.$moment(selectedDate).isAfter(cutOffDate)) {
      //     this.cutoffTime = true
      // } 
     
      // add 1 day if cutoff time
      // if (this.cutoffTime) {
      //     let nextWorkingDay = this.$moment(selectedDate)
      //                              .add(1, 'day')
      //     let nextcurrentTime = this.$moment(currentTime)
      //                              .add(1, 'day')             
      //     nextcurrentTime = this.$momenttz(nextcurrentTime, 'DD/MM/YYYY HH:mm:00ZZ', 'Asia/Riyadh').format('YYYY-MM-DDT09:00:00ZZ')                                              
      //     nextWorkingDay = this.$momenttz(nextWorkingDay, 'DD/MM/YYYY 16:30:00ZZ', 'Asia/Riyadh').format('YYYY-MM-DDT09:00:00ZZ')          
          
      //     console.log("nextcurrentTime: "+ nextcurrentTime)
      //     console.log("before selectedDate  : "+ selectedDate.format())
      //     console.log("nextWorkingDay: "+ nextWorkingDay)

      //     this.lessThan48Hours = this.$moment(nextWorkingDay)
      //                        .subtract(50, 'hours')
      //                        .isBefore(nextcurrentTime)  
          
      //     console.log("nextWorkingDay: "+ this.$momenttz(nextWorkingDay).toDate())

      //     this.nextWorkingDate = this.$momenttz(nextWorkingDay).toDate()

      //     setTimeout(function () {
      //            this.selectedDate = this.$momenttz(nextWorkingDay).toDate()

      //            console.log("after selectedDate  : "+ this.selectedDate)
      //         }.bind(this), 300)
      // }
      // else {
          // this.lessThan48Hours = this.$moment(selectedDate)
          //                    .subtract(50, 'hours')
          //                    .isBefore(currentTime)    
      // }

      
      this.selectedEmergencyId = null
      

      //let recommendedDate = null

      // if (this.$moment(selectedDate).isAfter(cutOffDate)) {        
      //     nextSelectedDate = this.$momenttz(selectedDate).add(1, 'day')
      //     nextSelectedDate = this.$momenttz(nextSelectedDate,'DD/MM/YYYY 16:30:00ZZ', 'Asia/Riyadh').format('YYYY-MM-DDT09:00:00ZZ')

          
      //     //nextSelectedDate = this.$momenttz(nextSelectedDate).add(50, 'hours')

      //     this.lessThan48Hours = this.$moment(nextSelectedDate)
      //                            .subtract(50, 'hours')
      //                            .isBefore(currentTime)  
      //     // console.log('nextSelectedDate: '+ nextSelectedDate) 
      //     // console.log('recommendedDate: '+ recommendedDate.format()) 
      // } 
      // else {
        
      // // this.$moment(startDate, 'DD/MM/YYYY HH:mm:ss').format()
      
      //console.log("nextWorkingDay: "+ nextWorkingDay)
      //console.log("Selected Date: "+ selectedDate.format())
      //console.log("Asia Riyadh Date: "+  currentTime.format())
      //console.log("Less than 48 Hours: "+  this.lessThan48Hours)
    },

    fileUploadEventHandler(event) {

      const notificationId = this.nvNumber
      const requestTypeId = this.selectedRequestTypeId
      const category = this.$_.find(this.$store.state.emergencyNotificationList, {id:this.selectedEmergencyId}).description.replace(/ /g,"_").toUpperCase()
      
      let file = event.file
      if (!file) return

      let formData = new FormData()
      formData.append('file', file, file.name)

      this.showUploadAlert = true
      
      UploadService.upload(formData, notificationId, requestTypeId, category, event.description).then( (resp) => {
          if (resp.length > 0) {
              this.isUploadReady = true              
              setTimeout(function () {
                  this.showUploadAlert = false
                  this.$refs.fileUpload.reset()
                }.bind(this), 3000) 
          }          
      })
    }
  }
}
</script>
<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

  .select-wrap {
  width: 200px;
  max-width: 100%; /* So it doesn't overflow from it's parent */
  }

  .select-wrap option {
    /* wrap text in compatible browsers */
    -moz-white-space:pre-wrap; 
    -o-white-space:pre-wrap; 
    white-space:pre-wrap; 

    /* hide text that can't wrap with an ellipsis */
    overflow: hidden;
    text-overflow:ellipsis;

    /* add border after every option */
    border-bottom: 1px solid #DDD;
  }

</style>



// WEBPACK FOOTER //
// src/views/UserDashboard.vue